export default __webpack_public_path__ + "img/ic-loan.986c105c.svg";